<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{ datas.created_at }}
        </h4>
      </div>
      <div class="col-md-6 end">
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        <router-link class="btn btn-danger" :to="{ path: '/money-transfer/index' }">
          <button type="button" class="closebutton">
          <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
       <div class="col-md-1 topheader">
        <span>
          <label for="">Факт №</label>
          <input :disabled="changedisabled" type="number" class="input100" v-model="datas.number">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label for="">{{$t('Вақт')}}</label>
          <input :disabled="changedisabled" type="datetime-local" class="input100" v-model="datas.created_at">
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Склад1</label>
            <v-select
              :clearable="false"
              class="form-control-sm required md-input"
              :options="skladlist"
            :disabled="skladhave"
              v-model="datas.sklad_id"
              :reduce="name => name.id"
              label="name"
            >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                aria-activedescendant="null"
              />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em
                  ><b>{{ search }}</b></em
                >
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
            </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
          <label>Склад2</label>
          <v-select
          :disabled="changedisabled"
            :clearable="false"
            class="form-control-sm required md-input"
            :options="skladlist2"
            v-model="datas.transfer_sklad_id"
            :reduce="name => name.id"
            label="name"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                ref="focused"
                v-bind="attributes"
                v-on="events"
                aria-activedescendant="null"
              />
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em
                  ><b>{{ search }}</b></em
                >
                {{ $t("бўйича маьлумот йўқ") }}
              </template>
              <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-3 topheader">
        <span>
            <label>Комментарий</label>
            <input
            :disabled="changedisabled"
              v-model="datas.comment"
              class="needt"
              type="text"
            >
        </span>
      </div>
    </div>
    <div class="table100percent">
      <md-card>
        <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="column5">№</th>
                <th class="column5">Сумма</th>
                <th class="column5">{{ $t("Тўлов тури") }}</th>
                <th class="column5"></th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;">
              <div
                style="overflow-y: scroll; height: 62vh !important; width: 100%;"
              >
              <tr v-for="(item, index) in datas.money_transfer_table" :key="index">
                <td class="column5">{{ index + 1 }}</td>
                <td class="column5">
                  <vue-numeric :disabled="changedisabled"
                    separator="space"
                    v-model="item.summa"
                    class="table-input"
                    v-bind:precision="2"
                    @change="Changed(index)"
                  >
                  </vue-numeric>
                </td>
                <td class="column5">
                  <v-select :disabled="changedisabled"
                    :clearable="false"
                    class="form-control-sm required md-input"
                    :options="paytypelist"
                    v-model="item.pay_type_id"
                    :reduce="name => name.id"
                    label="name"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                    </template>
                  </v-select>
                </td>
                <td class="column5">
                  <a  v-if="!changedisabled"
                    href="javascript:void(0)"
                    class="circul trash"
                    @click="Trashitem(index)"
                  >
                    <b-icon icon="trash"></b-icon>
                  </a>
                </td>
              </tr>
              </div>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </div>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-2 end topminus">
        <span>Сумма</span>
        <h4>{{datas.total}}</h4>
      </div>
      <div class="col-md-6 end formbottom">
        <button v-if="!changedisabled" class="mybtn btn addrow" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button v-if="!changedisabled" class="mybtn btn saved" type="button" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { print } from "../../components/mixins/print.js";
export default {
  name: "KirimForm",
  mixins: [print],
  data() {
    return {
      skladlist2:[],
      paytypelist: [],
      settedindex: null,
      sklad: "",
      paytype: "",
      skladlist: []
    };
  },
  props: ["datas"],
  created: function() {
    let self = this;
    self.$root.$refs.moneytransfer = self;
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.$root.$on("paytypeone", function(getdata) {
      self.paytype = getdata;
    });
    self.$root.$on("paytypeall", function(getdata) {
      self.paytypelist = getdata;
    });
  },
  mounted: function() {
    this.Focus();
    setTimeout(() => {
      this.SetRule('/money-transfer/index');
      this.datas.created_at=this.SetDatetime(this.datas.created_at);
    }, 1000);
    this.Skladlist2();
  },
  methods: {
     Skladlist2(){
      let self = this;
      axios
        .get("api/v1/sklads/skladnames")
        .then(function(response) {
          self.skladlist2 = response.data;
        });
    },
    Changed(index) {
      if (this.datas.money_transfer_table.length == index + 1) {
        this.Addtable();
      }
      this.Summa();
    },
    handlerClose: function(event) {
      if (this.$store.state.saved == null) {
        this.$store.state.saved = null;
      } else {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Savedokument();
          event.returnValue = "";
        } else {
          this.$store.state.saved = null;
        }
      }
    },
    Trashitem(index) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        this.datas.money_transfer_table.splice(index, 1);
        this.Summa();
      }
    },
    Focus() {
      if (this.$route.path == "/money-transfer/create") {
        this.$refs.focused.focus();
      } else {
        setTimeout(() => {
          $(".table-input")
            .eq(0)
            .focus();
        }, 100);
      }
    },
    Addtable() {
      this.datas.money_transfer_table.push({ pay_type_id: 1, summa: 0 });
      this.Tablefocus();
    },
    Summa() {
      this.datas.total = 0;
      let self = this;
      this.datas.money_transfer_table.forEach(function(key, value) {
        self.datas.total += parseInt(key.summa);
      });
    },
    Savedokument() {
      let self = this;
            // if(self.rule.change==true){
      if (this.$route.path == "/money-transfer/create") {
        var methods = "post";
        var action = "api/v1/money-transfer";
      } else {
        self.datas.updated_at = new Date()
          .valueOf()
          .toString()
          .slice(0, 10);
        var methods = "patch";
        var action = "api/v1/money-transfer/id/" + self.$route.params.id;
      }
       self.datas.created_at = new Date(self.datas.created_at)
        .valueOf()
        .toString()
        .slice(0, 10);
      axios({
        method: methods,
        url: action,
        data: self.datas
      }).then(function(response) {
        self.$store.state.saved = null;
        self.$router.push({ name: "Перемешения касса" });
      });
    // } else{
    //       self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
    // }
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card-content > .table.table-bordered tbody {
  display: block;
  height: 70vh;
  overflow-y: scroll;
}

.md-card-content > .table.table-bordered thead,
.md-card-content > .table.table-bordered tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
</style>
